import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
const navLinks = [{
  name: 'Servicios',
  href: '/servicios'
}, {
  name: 'Proceso',
  href: '/proceso'
}, {
  name: 'Enfoque',
  href: '/resultados'
}, {
  name: 'FAQ',
  href: '/faq'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 16);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b transition-[background-color,border-color,padding] duration-300 ${isScrolled ? 'border-white/10 bg-black/90 py-3 backdrop-blur-md' : 'border-transparent bg-transparent py-5'}`} data-id="element-51" data-mp="1l1kooaol21iv">
      <div className="container mx-auto flex items-center justify-between px-6 md:px-12" data-id="element-52" data-mp="jnoxm930jeem">
        <Link to="/" className="relative z-50 inline-flex items-center gap-3 text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" aria-label="Growthly, inicio" data-id="element-53" data-mp="om06ohlhhkvs">
          <span className="flex h-8 w-8 items-center justify-center border border-white/30 text-[11px] font-semibold tracking-[-0.08em]" data-id="element-54" data-mp="wfk7oq4g5hr">
            G
          </span>
          <span className="text-sm font-semibold tracking-[0.18em]" data-id="element-55" data-mp="5oyxekkwcym1">
            GROWTHLY
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Navegación principal" data-id="element-56" data-mp="39bplium6t6oh">
          {navLinks.map(link => {
          const isActive = location.pathname === link.href;
          return <Link key={link.href} to={link.href} aria-current={isActive ? 'page' : undefined} className={`relative px-3 py-2 text-[12px] font-medium tracking-wide transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${isActive ? 'text-white' : 'text-neutral-400 hover:text-white'}`} data-id="element-57" data-mp="2wbf023z87ucp">
                {link.name}
                {isActive && <motion.span layoutId="nav-indicator" className="absolute inset-x-3 bottom-0 h-px bg-white" transition={{
              type: 'spring',
              stiffness: 450,
              damping: 38
            }} data-id="element-58" data-mp="2sabq1y3v0sje" />}
              </Link>;
        })}
          <Link to="/contacto" className="ml-4 px-3 py-2 text-[12px] font-medium tracking-wide text-neutral-300 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-59" data-mp="a523zd12wybd">
            Contacto
          </Link>
          <Link to="/checkout" className="ml-3 inline-flex items-center gap-2 bg-white px-4 py-2.5 text-[12px] font-semibold text-black transition-colors hover:bg-neutral-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-60" data-mp="55pkn29f29dj">
            Empezar <ArrowUpRightIcon size={14} aria-hidden="true" data-id="element-61" data-mp="k26t9lq819we" />
          </Link>
        </nav>

        <button type="button" className="relative z-50 inline-flex h-10 w-10 items-center justify-center border border-white/15 text-white transition-colors hover:border-white/40 lg:hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-white" onClick={() => setIsMobileMenuOpen(isOpen => !isOpen)} aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isMobileMenuOpen} data-id="element-62" data-mp="o3iap3yxyoti">
          {isMobileMenuOpen ? <XIcon size={19} data-id="element-63" data-mp="3f2zghfistsg3" /> : <MenuIcon size={19} data-id="element-64" data-mp="3f4iwr64gg3hv" />}
        </button>

        <AnimatePresence data-id="element-65" data-mp="3b25tqph3ejos">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -12
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -12
        }} transition={{
          duration: 0.22,
          ease: 'easeOut'
        }} className="absolute inset-x-0 top-0 min-h-screen bg-black px-6 pb-10 pt-28 lg:hidden" data-id="element-66" data-mp="3b3qoaf3eq2mn">
              <nav aria-label="Navegación móvil" data-id="element-67" data-mp="ufd44m0fps90">
                <ul className="border-t border-white/10" data-id="element-68" data-mp="plqxbagycil4">
                  {[{
                name: 'Inicio',
                href: '/'
              }, ...navLinks, {
                name: 'Contacto',
                href: '/contacto'
              }].map(link => <li key={link.href} className="border-b border-white/10" data-id="element-69" data-mp="2mae33wf99mlx">
                      <Link to={link.href} aria-current={location.pathname === link.href ? 'page' : undefined} className="flex items-center justify-between py-5 text-xl font-medium tracking-tight text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-70" data-mp="2r8xqm19hz6ge">
                        {link.name}
                        <ArrowUpRightIcon size={18} aria-hidden="true" data-id="element-71" data-mp="3a0qghmt9sbjw" />
                      </Link>
                    </li>)}
                </ul>
              </nav>
              <Link to="/checkout" className="mt-8 flex items-center justify-center gap-2 bg-white px-5 py-4 text-sm font-semibold text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-72" data-mp="1ewacar3q710p">
                Iniciar mi proyecto{' '}
                <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-73" data-mp="1xlpcykfi1o4k" />
              </Link>
              <p className="mt-4 text-center text-xs text-neutral-500" data-id="element-74" data-mp="1tkn9tsigorxb">
                Oferta única · 350€ · Sin cuotas
              </p>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}